import Head from "next/head";
import { useEffect, useState } from "react";
import { getVideosWithThumbnails } from "util/videoThumbnailUtil";

type Video = {
  title: string;
  uploadDate?: string;
  duration?: string;
  contentUrl?: string;
  thumbnailUrl?: string; //
};

interface Props {
  videos: Video[];
}

export default function VideosMetaData({ videos = [] }: Props) {
  if (!videos || videos.length === 0) return null;
  const [videoThumbnails, setVideoThumbnails] = useState(videos);

  useEffect(() => {
    getVideosWithThumbnails(videos).then((_) => {
      setVideoThumbnails(_);
    });
  }, []);

  const itemListElement = videoThumbnails.map((video, index) => {
    const validUploadDate = video.uploadDate && !isNaN(new Date(video.uploadDate).getTime())
      ? new Date(video.uploadDate).toISOString()
      : undefined;

    return {
      "@type": "VideoObject",
      position: index + 1,
      name: video.title,
      description: video.title,
      thumbnailUrl: video.thumbnailUrl || video.thumbnailSrc,
      ...(validUploadDate && { uploadDate: validUploadDate }),
      ...(video.duration && { duration: video.duration }),
      ...(video.contentUrl && { contentUrl: video.contentUrl }),
    };
  });

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </Head>
  );
}
